import { DashboardResponse } from "@practium/features/api";
import { DashboardConfig } from "@practium/features/dashboard";
import { CoffeeIcon, PlantIcon, SuppliesIcon } from "@practium/ui";
import { farmerAnalysisConfig, farmerAnalysisTypeDonutConfig, farmerPropertiesConfig, farmerRecommendationsChartConfig } from "./farmerCharts.config";
import { getFarmerChartsData } from "./mappers";

export const getFarmerDashboardConfig = (data?: DashboardResponse): DashboardConfig => {
    const {
        analysisTypeData,
        recommendationsData,
        propertiesData,
        analysisData
    } = getFarmerChartsData(data);
    return {
        stats: [
            {
                id: 'propriedades',
                label: 'Propriedades',
                value: data?.cards[0].value || null,
                trendValue: data?.cards[0].variationPercent || null,
                trendLabel: 'propriedade adicionada',
                trendDirection: (data?.cards?.[0]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <PlantIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'analises',
                label: data?.cards[1].title || 'Análises Realizadas',
                value: data?.cards[1].value || null,
                trendValue: data?.cards[1].variationPercent || null,
                trendLabel: 'este mês',
                trendDirection: (data?.cards?.[1]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <SuppliesIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
            {
                id: 'cafe',
                label: 'Lavouras de Café',
                value: data?.cards[2].value || null,
                valueFormatter: (v) => `${v.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ha`,
                trendValue: data?.cards[2].variationPercent || null,
                trendLabel: 'em produção',
                trendDirection: (data?.cards?.[2]?.variationPercent ?? 0) > 0 ? 'up' : 'down',
                icon: <CoffeeIcon style={{ fontSize: '1.5rem', color: 'var(--icon-default)' }} />,
            },
        ],
        promotion: {
            title: 'Solicite uma análise de\nsolo',
            subtitle: 'Receba recomendações \npara sua propriedade',
            buttonText: 'Nova Análise',
            onButtonClick: '/analises',
        },
        slots: [
            {
                type: 'donut',
                size: 'oneThird',
                config: farmerAnalysisTypeDonutConfig,
                data: analysisTypeData,
            },
            {
                type: 'pie',
                size: 'oneThird',
                config: farmerRecommendationsChartConfig,
                data: recommendationsData,
            },
            {
                type: 'metricList',
                size: 'oneThird',
                config: farmerPropertiesConfig,
                data: propertiesData,
            },
            {
                type: 'metricList',
                size: 'oneThird',
                config: farmerAnalysisConfig,
                data: analysisData,
            }
        ]
    }
}
